<template>
    <div class="modal-fair">
        <div class="fair-header">
            <div class="header-icon">
                <img src="@/assets/img/fair.png" alt="fair" />
            </div>
            <span class="gradient-green">{{ $t('modal.64') }}</span>
        </div>
        <div class="fair-info">
            {{ $t('modal.65') }}
            
        </div>
        <div class="fair-nav">
            <button v-on:click="modalSetGame('Blackjack')" v-bind:class="{ 'button-active': modalGame === 'Blackjack' }">
                <div class="button-inner">
                    <span>BLACKJACK</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Roll')" v-bind:class="{ 'button-active': modalGame === 'Roll' }">
                <div class="button-inner">
                    <span>ROLL</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Crash')" v-bind:class="{ 'button-active': modalGame === 'Crash' }">
                <div class="button-inner">
                    <span>CRASH</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Duels')" v-bind:class="{ 'button-active': modalGame === 'Duels' }">
                <div class="button-inner">
                    <span>DICE DUELS</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Mines')" v-bind:class="{ 'button-active': modalGame === 'Mines' }">
                <div class="button-inner">
                    <span>MINES</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Towers')" v-bind:class="{ 'button-active': modalGame === 'Towers' }">
                <div class="button-inner">
                    <span>TOWERS</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Battles')" v-bind:class="{ 'button-active': modalGame === 'Battles' }">
                <div class="button-inner">
                    <span>BATTLES</span>
                </div>
            </button>
            <button v-on:click="modalSetGame('Unbox')" v-bind:class="{ 'button-active': modalGame === 'Unbox' }">
                <div class="button-inner">
                    <span>UNBOX</span>
                </div>
            </button>
        </div>
        <div class="fair-content">
            <component v-bind:is="'Fair' + modalGame" />
        </div>
    </div>
</template>

<script>
    import FairBlackjack from '@/components/fair/FairBlackjack';
    import FairRoll from '@/components/fair/FairRoll';
    import FairCrash from '@/components/fair/FairCrash';
    import FairDuels from '@/components/fair/FairDuels';
    import FairMines from '@/components/fair/FairMines';
    import FairTowers from '@/components/fair/FairTowers';
    import FairUnbox from '@/components/fair/FairUnbox';
    import FairBattles from '@/components/fair/FairBattles';

    export default {
        name: 'ModalFair',
        components: {
            FairBlackjack,
            FairRoll,
            FairCrash,
            FairDuels,
            FairMines,
            FairTowers,
            FairUnbox,
            FairBattles
        },  
        data() {
            return {
                modalGame: 'Blackjack'
            }
        },
        methods: {
            modalSetGame(game) {
                this.modalGame = game;
            }
        }
    }
</script>

<style scoped>
.modal-fair {
    width: 860px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 30px 30px 30px;
    border-radius: 15px;
    background: var(--background);
}

/* Header */
.modal-fair .fair-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-fair .header-icon {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: linear-gradient(255deg, rgb(95 0 255 / 20%) 0%, rgb(81 0 170 / 20%) 100%);
}
.modal-fair .header-icon img {
    width: 48px;
    height: 48px;
}
.modal-fair .fair-header span {
    margin-top: 20px;
    text-align: center;
    font-size: 32px;
    font-weight: 900;
}

/* Info */
.modal-fair .fair-info {
    width: 100%;
    margin-top: 12px;
    padding-bottom: 30px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #bbbfd0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

/* Nav */
.modal-fair .fair-nav {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    padding: 4px;
    background: var(--background2);
    border-radius: 10px;
}
.modal-fair .fair-nav button {
    height: 48px;
    position: relative;
    margin-right: 4px;
    padding: 1px;
    z-index: 1;
}
.modal-fair .fair-nav button:last-of-type {
    margin-right: 0;
}
.modal-fair .fair-nav button .button-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
}
.modal-fair .fair-nav button.button-active .button-inner {
    background: var(--background4);
    border-radius: 10px;
}
.modal-fair .fair-nav button .button-inner span {
    font-size: 14px;
    font-weight: 800;
    color: #bbbfd0;
}
.modal-fair .fair-nav button.button-active .button-inner span {
    background: #fff;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

/* Content */
.modal-fair .fair-content {
    width: 100%;
    margin-top: 30px;
}

/* Tablet */
@media only screen and (max-width: 955px) {
    .modal-fair {
        width: calc(100vw - 20px);
        padding: 85px 15px 48px 15px;
    }
}

/* Mobil (bottom sheet) */
@media only screen and (max-width: 500px) {
    .modal-fair {
        width: 100vw;                  /* tam genişlik */
        max-width: 100%;
        border-radius: 20px 20px 0 0;  /* sadece üst köşeler yuvarlak */
        padding: 65px 15px 40px 15px;
    }
}

/* Küçük tabletlerde nav grid */
@media only screen and (max-width: 825px) {
    .modal-fair .fair-nav button {
        width: calc(25% - 3px);
    }
    .modal-fair .fair-nav button:nth-child(4n) {
        margin-right: 0;
    }
    .modal-fair .fair-nav button .button-inner {
        padding: 0;
    }
}
</style>

